import React, {useState} from 'react'
import './Banner.css'
import {Button} from "@material-ui/core";
import Search from './Search';
import {useHistory} from "react-router-dom";

function Banner() {
    const history = useHistory();
    const [showSearch, setShowSearch] = useState(false); //State for search dates button so it changes state when clicked to "hide"

    return (
        <div className='banner'>
            <div className="banner_search">
                {showSearch && <Search />}
                <Button onClick={() =>
                 setShowSearch(!showSearch)}  //this function will change on click to what is not showSearch currently
                className="banner_searchbutton" variant='outlined'>
                    {showSearch ? "Hide" : "Search Dates"}
                </Button>
            </div>
            <div className="banner_info">
                <h1>Get out and stretch your imagination</h1>
                <h5>
                    Plan a different king of getaway to uncover the hidden
                    gems near you.
                </h5>
                <Button onClick={()=> history.push('/Search')}
                variant='outlined'>Explore Nearby</Button>
            </div>
        </div>
    )
}

export default Banner
